<template>
  <div>
    <b-card no-header class="brief-link-abm">
      <form>
        <b-form-group
          label="Link"
          label-for="link"
          :labelCols="labelCols"
          horizontal>
          <b-form-input 
            id="link"
            v-model.trim="$v.link.$model" 
            :state="linkValido"
            type="text"
            @blur.native="validate">
          </b-form-input>
          <b-form-invalid-feedback id="linkFeedback">
            {{ linkInvalidoMsj }}
          </b-form-invalid-feedback>
        </b-form-group>

        <b-form-group
          label="Descripción"
          label-for="descripcion"
          :labelCols="labelCols"
          horizontal>
          <b-form-input 
            id="descripcion"
            v-model.trim="$v.descripcion.$model" 
            :state="descripcionValida"
            type="text"
            @blur.native="validate">
          </b-form-input>
          <b-form-invalid-feedback id="descripcionFeedback">
            {{ descripcionInvalidaMsj }}
          </b-form-invalid-feedback>          
        </b-form-group>
      </form>
      <div slot="footer">
        <b-button size="sm" variant="primary" class="footer-button"
          @click.prevent="save">Grabar</b-button>
        <b-button size="sm" variant="danger" class="footer-button" 
          @click.prevent="cancelar">Cancelar</b-button>
      </div>
    </b-card>

    <mensaje
      :modalMsj="modalMsj"
      :modalMensaje="modalMensaje"
      @okAction="okAction"
      @hiddenAction="hiddenAction">
    </mensaje>
  </div>
</template>

<script>
import Mensaje from '../shared/msjModal.vue';
import { msjModal } from '../../mixins/modalDialogs'
import { required, maxLength } from 'vuelidate/lib/validators';

export default {
  name: 'BriefLink',
  components: {
    Mensaje
  },
  mixins: [ 
    msjModal 
  ],
  data () {
    return {
      link: '',
      descripcion: '',

      noValidar: true,
      linkValido: null,
      linkInvalidoMsj: '',
      descripcionValida: null,
      descripcionInvalidaMsj: '',

      labelCols: 2,
    }
  },
  created() {
  },  
  methods: {
    validate(event) {
      if (event) {
        if (event.target) {
          /* Antes de intentar registrar por primera vez, no validamos */
          if (!this.noValidar){
            this.$v.$touch();
            this.displayErrores(event.target.id);
          }
        }
      } 
    },
    displayErrores(field) {
      var validarTodos = false;
      var campo = '';

      if (field) {
        campo = field;
      } else {
        validarTodos = true;
      }
      
      if (campo == 'link' || validarTodos) {
        if (this.$v.link.$error) {
          this.linkValido = false;
          if (!this.$v.link.required) {
            this.linkInvalidoMsj = 'Debe ingresar el link solicitado';
          } else if (!this.$v.link.maxLength) {
            this.linkInvalidoMsj = 'El link solo pueden contener hasta 5000 caracteres';
          }      
        } else {
          this.linkValido = null;
          this.linkInvalidoMsj = '';
        }
      }

      if (campo == 'descripcion' || validarTodos) {
        if (this.$v.descripcion.$error) {
          this.descripcionValida = false;
          if (!this.$v.descripcion.maxLength) {
            this.descripcionInvalidaMsj = 'La descripción solo pueden contener hasta 500 caracteres';
          }      
        } else {
          this.descripcionValida = null;
          this.descripcionInvalidaMsj = '';
        }
      }
    },
    save () {
      /* Antes de intentar registrar por primera vez, no validamos */
      this.noValidar = false;

      this.$v.$touch();

      let save = true;

      if (save) {
        if (this.$v.$anyError) {
          this.displayErrores();
        } else {
          let params = {
            link: this.link,
            descripcion: this.descripcion
          }

          this.$emit('saved', params);
        }
      }
    },
    cancelar() {
      this.$emit('close')
    },
  },
  validations: {
    link: {
      required,
      maxLength: maxLength(5000)
    },
    descripcion: {
      maxLength: maxLength(500)
    },
  },  
  watch: {
  }    
}
</script>

<style>
  .brief-link-abm .form-group input {
    text-transform: none !important;
  } 
</style>
